import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=a8baa566&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=a8baa566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8baa566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8baa566')) {
      api.createRecord('a8baa566', component.options)
    } else {
      api.reload('a8baa566', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=a8baa566&scoped=true&", function () {
      api.rerender('a8baa566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Landing.vue"
export default component.exports